import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { HttpModule } from './http.module';
import {
  HttpAuthenticationProvider,
  HttpRequestClient,
  HttpEndpoint,
  HttpRequest,
} from 'src/app/client/core';
import { HttpErrorHandler } from './http-error-handler';
import { CustomerPortalProvider } from 'src/app/client/core/lib/http-customer-portal.provider';

@Injectable({
  providedIn: HttpModule,
})
export class OneHttpClientService extends HttpRequestClient {
  constructor(
    _httpClient: HttpClient,
    _httpEndpoint: HttpEndpoint,
    _authProvider: CustomerPortalProvider,
    _errorHandler: HttpErrorHandler
  ) {
    super(_httpClient, _httpEndpoint);
    this.authProvider = _authProvider;
    this.errorHandler = _errorHandler;
  }

  public override callObject<R>(request: HttpRequest): Observable<R> {
    return this.call<R>(request).pipe<R>(map((response: any) => response.body));
  }
}
